import { useCallback } from "react";
import { NavLink } from "react-router-dom";
import { onPolicyClick } from "../analytics/analytics.click-handlers";
import Colors from "../assets/constants/Colors";
import {
  contactTitleId,
  footerContent,
} from "../assets/constants/Strings";
import { RoutePath } from "../navigation/Routing";
import styled from "../styled-components";
import SocialMediaBar from "./SocialMediaBar";

const Footer = () => {
  const onLinkClick = useCallback((href: string, targetText: string) => (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    onPolicyClick({href, targetText})
  },[]);;

  return (
    <FooterContainer id={contactTitleId}>
      <ContentContainer>
        <FarwellLabel>{footerContent.farwellMessage}</FarwellLabel>
        <SocialMediaBar />
        <BodyText>{footerContent.copyrightMessage}</BodyText>
        <PoliciesContainer>
          Policies:
          <StyledPolicyLink onClick={onLinkClick(RoutePath.PrivacyPolicy, footerContent.privacyPolicyTitle)} to={RoutePath.PrivacyPolicy}>{footerContent.privacyPolicyTitle}</StyledPolicyLink>
          <Separator>{"|"}</Separator>
          <StyledDisclaimerLink onClick={onLinkClick(RoutePath.Disclaimer, footerContent.disclaimerTitle)} to={RoutePath.Disclaimer}>{footerContent.disclaimerTitle}</StyledDisclaimerLink>
        </PoliciesContainer>
      </ContentContainer>
    </FooterContainer>
  );
};

const FooterContainer = styled.footer`
  background-color: ${Colors.surfaceForeground};
  border-top: 1px solid ${Colors.surfaceForegroundBorder};
  text-align: center;
    :hover {
      color: ${Colors.surfaceForegroundNavigationLinksHover};
    }
`;

const ContentContainer = styled.div`
  margin: 0 auto;
  max-width: 950px;
  overflow: auto;
  padding: 60px 50px;
`;

const FarwellLabel = styled.h2`
  margin-bottom: 10px;
`;

const BodyText = styled.p``;

const StyledPolicyLink = styled(NavLink)`
  font-size: 10px;
  padding-left: 5px;
`;

const StyledDisclaimerLink = styled(NavLink)`
  font-size: 10px;
`;

const Separator = styled.p`
margin: 0;
  padding: 0 4px;
`;

const PoliciesContainer = styled.p`
  font-size: 10px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;


export default Footer;
